'use client'

import {
	SidebarGroup,
	SidebarGroupLabel,
	SidebarMenu,
	SidebarMenuButton,
} from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'
import { Link, useLocation } from 'react-router-dom'

import type { LucideIcon } from 'lucide-react'

export function NavSection({
	title,
	items,
}: {
	title: string
	items: {
		title: string
		url: string
		icon?: LucideIcon
		isActive?: boolean
		matchPattern?: string | ((pathname: string) => boolean)
		items?: {
			title: string
			url: string
		}[]
	}[]
}) {
	const location = useLocation()

	return (
		<SidebarGroup>
			<SidebarGroupLabel>{title}</SidebarGroupLabel>
			<SidebarMenu>
				{items.map((item) => {
					let isItemActive = false

					if (item.matchPattern) {
						if (typeof item.matchPattern === 'string') {
							// If matchPattern is a string, treat it as a regex
							const regex = new RegExp(item.matchPattern)
							isItemActive = regex.test(location.pathname)
						} else if (typeof item.matchPattern === 'function') {
							// If matchPattern is a function, call it with the pathname
							isItemActive = item.matchPattern(location.pathname)
						}
					} else {
						// Default behavior: exact match or ends with the last part of the URL
						isItemActive =
							location.pathname === item.url ||
							location.pathname.endsWith(item.url.split('/').pop() || '')
					}

					return (
						<SidebarMenuButton
							tooltip={item.title}
							asChild
							key={item.title}
							className={cn(isItemActive && 'bg-sidebar-accent text-sidebar-accent-foreground')}
						>
							<Link to={item.url}>
								{item.icon && <item.icon />}
								<span>{item.title}</span>
							</Link>
						</SidebarMenuButton>
					)
				})}
			</SidebarMenu>
		</SidebarGroup>
	)
}
